import { useEffect, useState, useRef } from "react";
import { motion, useInView } from "framer-motion";
import { Link } from "react-router-dom";
import API_BASE_URL from "../config/Config.js";
import { SectionTitle, SkeletonCard } from "./ui";
import "./TeamSection3D.css";

const mockData = [
  {
    id: "1",
    name: "Секеров Алибек Жайлаубаевич",
    image_url: "/images/team/170A7179_resized.jpg",
    extra_role: "Генеральный директор Учреждения адвокатской конторы \"Sekerov&partners\""
  },
  {
    id: "2",
    name: "Шакиржанов Руслан Сейпиевич",
    image_url: "/images/team/170A7345_resized.jpg",
    extra_role: "Специалист системы менеджмента и качества КазНУИ \"ШАБЫТ\""
  },
  {
    id: "3",
    name: "Баубериков Газиз Жолдасбекович",
    image_url: "/images/team/170A7127_resized.jpg",
    extra_role: "директор института Стратегических гуманитарных исследований АВН РК"
  },
  {
    id: "4",
    name: "Ғабдолла Алишер Найманұлы",
    image_url: "/images/team/170A7098_resized.jpg",
    extra_role: "Учредитель \"Nai Production\""
  },
  {
    id: "5",
    name: "Еликбаева Алтынай Талгатовна",
    image_url: "/images/team/IMG_5146.JPG",
    extra_role: ""
  },
  {
    id: "6",
    name: "Алмажанова Кульзат Каналхановна",
    image_url: "/images/team/IMG_5154.JPG",
    extra_role: "Председатель ОО \"Жасыл Желкен\""
  },
];

export default function TeamSection() {
  const [teamMembers, setTeamMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.2 });

  useEffect(() => {
    fetch(`${API_BASE_URL}/users/workers/`)
      .then((res) => res.json())
      .then((data) => {
        if (data?.data && data.data.length > 0) {
          setTeamMembers(data.data);
        } else {
          setTeamMembers(mockData);
        }
      })
      .catch((err) => {
        console.error("Ошибка загрузки команды:", err);
        setTeamMembers(mockData);
      })
      .finally(() => setLoading(false));
  }, []);

  const getMemberName = (member) => {
    return member.name || `${member.first_name || ''} ${member.last_name || ''}`.trim() || 'Участник команды';
  };

  const getMemberImage = (member) => {
    return member.image_url || member.imageUrl || member.image || "https://via.placeholder.com/400x500?text=Фото";
  };

  if (loading) {
    return (
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionTitle
          subtitle="Наши люди"
          title="Команда"
          description="Профессионалы, которые делают нашу работу возможной"
          className="mb-8 md:mb-10"
        />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {[...Array(6)].map((_, i) => (
            <SkeletonCard key={i} />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div ref={ref} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionTitle
        subtitle="Наши люди"
        title="Команда"
        description="Профессионалы, которые делают нашу работу возможной"
        className="mb-8 md:mb-10"
      />

      <div className="team-carousel-shell">
        <div className="inner wide" style={{ "--quantity": teamMembers.length }}>
          {teamMembers.map((member, index) => (
            <div className="card" style={{ "--index": index }} key={member.id || index}>
              <div
                className="img"
                style={{
                  backgroundImage: `url(${getMemberImage(member)})`,
                }}
                title={getMemberName(member)}
              >
                <div className="info">
                  <p className="name">{getMemberName(member)}</p>
                  <p className="position">{member.extra_role}</p>
                </div>
              </div>
            </div>

          ))}
        </div>
      </div>

      {/* View all button */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={isInView ? { opacity: 1 } : {}}
        transition={{ delay: 0.6 }}
        className="text-center mt-10"
      >
        <Link
          to="/team"
          className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-primary-500 to-teal-500 text-white font-semibold rounded-xl shadow-lg shadow-primary-500/30 hover:shadow-xl hover:shadow-primary-500/40 transition-all"
        >
          Вся команда
          <svg
            className="w-4 h-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M17 8l4 4m0 0l-4 4m4-4H3"
            />
          </svg>
        </Link>
      </motion.div>
    </div>
  );
}
